import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import { ActionPlansContext } from "context/ActionPlansContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { getFiles } from "services/ConfigServices";
import { getActionPlan, putActionPlanScenario } from "services/ConfigServices";
import {
  AutocompleteInput,
  AutocompleteInputDroppable,
  CustomSelect,
  CustomSwitch,
  DateInput,
  IntInput,
  TextInput,
} from "components/Input/Index.js";
import SubmitButton from "components/CustomButtons/SubmitButton";
import { planActions } from "variables/planActions";

function EditScenarioDialog(props) {
  const {
    closeModal,
    setLoading,
    selectedScenario,
    selectedScenarioId,
  } = props;

  const appContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = appContext;
  const [scenario, setScenario] = useState({});

  const [actionList, setActionList] = useState([]);

  console.log(scenario);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setScenario((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleActiveChange = (e) => {
    const { name, value } = e.target;
    setScenario((prevState) => ({
      ...prevState,
      [name]: value,
      activationdate: new Date().toISOString().slice(0, 10),
    }));
  };

  useEffect(() => {
    let selectedScenario = actionPlans.scenarios.find(
      (x) => x.id === selectedScenarioId
    ).parameters;
    setScenario(selectedScenario);
    //setAction(actionPlans.scenarios)
  }, [actionPlans]);

  useEffect(() => {
    actionPlans.actions.map((value) => {
      setActionList((prevState) => [
        ...prevState,
        {
          fileId: value.id,
          fileName: value.parameters.name,
        },
      ]);
    });
  }, [actionPlans]);

  const urlPlanAction = getActionPlan(actionPlans.id);

  const handleSubmit = (event) => {
    editActionPlanScenario(event);
    //setLoading(true);
    axios
      .get(urlPlanAction, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        setActionPlans(response.data || []);
      });
    closeModal();
  };

  const editActionPlanScenario = async (event) => {
    console.log(scenario);

    axios
      .put(putActionPlanScenario(selectedScenarioId), scenario, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setNotification("success", "Scénario modifié");
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        setLoading(false);
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const selectedActions = () => {
    let fileId = [];
    let getActionNames;
    if (scenario.associatedActions !== undefined) {
      for (let i = 0; i < scenario.associatedActions.length; i++) {
        fileId.push(scenario.associatedActions[i].fileId);
      }
      getActionNames = actionList.filter((actionList) =>
        fileId.includes(actionList.fileId)
      );
    }
    console.log(getActionNames);
    return getActionNames;
  };

  const handleAssociatedfilesChange = (newValue) => {
    //setAction(newValue);

    let newArray = [];

    for (let i = 0; i < newValue.length; i++) {
      newArray.push({
        fileId: newValue[i].fileId,
        fileName: newValue[i].fileName,
        position: i + 1,
      });
    }

    console.log(newArray);

    setScenario((prevState) => ({
      ...prevState,
      associatedActions: newArray,
    }));
  };

  const activeData = [
    { name: "Active", id: true },
    { name: "Inactive", id: false },
  ];

  const reclevelData = [
    { name: "Fortement recommandé", id: "high" },
    { name: "Recommandé", id: "medium" },
    { name: "Envisageable", id: "low" },
  ];

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={7}>
          <TextInput
            inputTitle={planActions.scenarios.name}
            textInput={scenario.name}
            handleTextInputChange={handleChange}
            name="name"
          />
          <TextInput
            inputTitle={planActions.scenarios.code}
            textInput={scenario.code}
            handleTextInputChange={handleChange}
            name="code"
          />
          <TextInput
            inputTitle={planActions.scenarios.description}
            textInput={scenario.description}
            handleTextInputChange={handleChange}
            name="description"
          />
          <CustomSelect
            inputTitle={"Statut"}
            selectValue={scenario.active || false}
            handleSelectValueChange={handleActiveChange}
            data={activeData}
            name="active"
          />
          <DateInput
            inputTitle={planActions.scenarios.activationdate}
            dateInput={scenario.activationdate}
            handleDateInputChange={handleChange}
            name="activationdate"
          />
          <IntInput
            inputTitle={planActions.scenarios.order}
            intInput={scenario.order}
            handleIntInputChange={handleChange}
            name="order"
          />
          <TextInput
            inputTitle={planActions.scenarios.feasibility}
            textInput={scenario.feasibility}
            handleTextInputChange={handleChange}
            name="feasibility"
          />
          <TextInput
            inputTitle={planActions.scenarios.grade}
            textInput={scenario.grade}
            handleTextInputChange={handleChange}
            name="grade"
          />
          <CustomSelect
            inputTitle={planActions.scenarios.reclevel}
            selectValue={scenario.reclevel || ""}
            handleSelectValueChange={handleChange}
            data={reclevelData}
            name="reclevel"
          />
          <TextInput
            inputTitle={planActions.scenarios.comments}
            textInput={scenario.comments}
            handleTextInputChange={handleChange}
            name="comments"
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={5} lg={5}>
          {/* <AutocompleteInput
            inputTitle={"Actions associées"}
            selected={selectedActions() || []}
            list={actionList}
            handleChange={(_, newValue) =>
              handleAssociatedfilesChange(newValue)
            }
            isMultiple
          /> */}
          <AutocompleteInputDroppable
            inputTitle={"Actions associées"}
            selected={scenario.associatedActions || []}
            list={actionList}
            handleChange={(_, newValue) =>
              handleAssociatedfilesChange(newValue)
            }
            isMultiple
          />
        </GridItem>

        <GridItem xs={12} sm={6} md={7} lg={7}>
          <SubmitButton handleSubmit={handleSubmit}>Modifier</SubmitButton>
        </GridItem>
      </GridContainer>
    </>
  );
}

export default EditScenarioDialog;
